export default __webpack_public_path__ + "static/media/check.3b570374.png";